var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconZoom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.059,
    height: 19.062,
    viewBox: "0 0 19.059 19.062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Zoom",
    transform: "translate(16515.75 23329.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.031,18.063a9.031,9.031,0,1,1,9.031-9.031A9.044,9.044,0,0,1,9.031,18.063Zm0-16.741a7.71,7.71,0,1,0,7.71,7.71A7.718,7.718,0,0,0,9.031,1.322Z",
    transform: "translate(-16515.75 -23329.75)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M2.748,3.5a.742.742,0,0,1-.53-.22L-1.029.021a.754.754,0,0,1,0-1.06.754.754,0,0,1,1.06,0L3.278,2.217a.754.754,0,0,1,0,1.06A.742.742,0,0,1,2.748,3.5Z",
    transform: "translate(-16500.186 -23314.186)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M5.75,1.5h-5A.755.755,0,0,1,0,.75.755.755,0,0,1,.75,0h5A.755.755,0,0,1,6.5.75.755.755,0,0,1,5.75,1.5Z",
    transform: "translate(-16509.93 -23321.145)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M.75,6.5A.755.755,0,0,1,0,5.75v-5A.755.755,0,0,1,.75,0,.755.755,0,0,1,1.5.75v5A.755.755,0,0,1,.75,6.5Z",
    transform: "translate(-16507.453 -23323.635)",
    fill: "#061133"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZoom);
export default __webpack_public_path__ + "static/media/Icon-Zoom.28611072975a507f2de807ce44f79c01.svg";
export { ForwardRef as ReactComponent };